export const isIntString= (str: string) => /^\d+$/.test(str)
